import { countryName } from '../../productOptions.js';

// Buying requests (migration 042): display helpers shared by the
// marketplace, the member area and the admin.

const locale = (lang) => (lang === 'en' ? 'en-CA' : 'fr-CA');

// 🇵🇰 from "PK" (regional indicator letters); nothing for unknown codes.
export const flag = (code) => (/^[A-Z]{2}$/.test(code || '') ? String.fromCodePoint(...[...code].map((c) => 0x1f1a5 + c.charCodeAt(0))) : '');

export function unitLabel(unit, t) {
  if (!unit) return '';
  const s = t(`units.${unit}`);
  return s.startsWith('units.') ? unit : s;
}

export function formatQty(n, unit, lang, t) {
  if (n === null || n === undefined || n === '') return '';
  return `${new Intl.NumberFormat(locale(lang), { maximumFractionDigits: 2 }).format(Number(n))}${unit ? ` ${unitLabel(unit, t)}` : ''}`;
}

export const money = (n, currency, lang) => (n === null || n === undefined ? '' : new Intl.NumberFormat(locale(lang), { style: 'currency', currency: currency || 'USD' }).format(Number(n)));

export const destination = (r, lang) => [r.destPort, countryName(r.destCountry, lang)].filter(Boolean).join(', ');

// "Livraison avant le 1 déc. 2026" or the free-text timeframe.
export function timeframeText(r, lang) {
  if (r.deliveryBy) return new Date(`${r.deliveryBy}T12:00:00`).toLocaleDateString(locale(lang), { day: 'numeric', month: 'short', year: 'numeric' });
  return r.timeframe || '';
}

export const shortDate = (iso, lang) => (iso ? new Date(/^\d{4}-\d{2}-\d{2}$/.test(iso) ? `${iso}T12:00:00` : iso).toLocaleDateString(locale(lang), { day: 'numeric', month: 'short', year: 'numeric' }) : '');

// Today + n days as YYYY-MM-DD (local), for date inputs.
export function inDays(n) {
  const d = new Date(); d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
